import { useState, useCallback } from 'react';

export function useSetState<T>(initialState: Set<T> = new Set()) {
  const [state, setState] = useState<Set<T>>(initialState);

  const addItem = useCallback((item: T) => {
    setState(prev => new Set(prev).add(item));
  }, []);

  const removeItem = useCallback((item: T) => {
    setState(prev => {
      const newSet = new Set(prev);
      newSet.delete(item);
      return newSet;
    });
  }, []);

  const clear = useCallback(() => {
    setState(new Set());
  }, []);

  const hasItem = useCallback((item: T) => {
    return state.has(item);
  }, [state]);

  return {
    state,
    setState,
    addItem,
    removeItem,
    clear,
    hasItem
  };
} 